.pauseIconBorderBtn {
    border: none;
    outline: 1.5px solid var(--mantine-color-white);
}

.removeParticipantIconBtn {
    border: none;
    outline: 1.5px solid var(--mantine-color-red-5);

    &:disabled {
        background-color: color-mix(in srgb, var(--mantine-color-dark-1), transparent 88%);
        outline: var(--mantine-color-dark-1);
        &:hover {
            background-color: color-mix(in srgb, var(--mantine-color-dark-1), transparent 88%);
        }
    }
}

.monospaceTimerText {
    letter-spacing: -1px;
    margin-left: 0.2rem;
}

.buttonSections {
    margin-right: 5px;
}
